export default __webpack_public_path__ + "static/media/Ocelots_Still_2.df3166e4.jpg";